const TRACKING_HEADER = 'X-Tracking-ID'

export function createTrackingId(): string {
  return (
    globalThis.crypto?.randomUUID?.() ??
    `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`
  )
}

export function withTrackingId(init: RequestInit = {}, trackingId: string = createTrackingId()): RequestInit {
  const headers = new Headers(init.headers)

  if (!headers.has(TRACKING_HEADER)) {
    headers.set(TRACKING_HEADER, trackingId)
  }

  return {
    ...init,
    headers,
  }
}

export function trackedFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  return fetch(input, withTrackingId(init))
}
